"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get PATIENT_EXPORT_NOT_INCLUDED_V1 () {
        return PATIENT_EXPORT_NOT_INCLUDED_V1;
    },
    get PATIENT_EXPORT_SCHEMA_VERSION () {
        return PATIENT_EXPORT_SCHEMA_VERSION;
    },
    get PATIENT_EXPORT_SECTIONS_V1 () {
        return PATIENT_EXPORT_SECTIONS_V1;
    },
    get PatientExportFormatSchema () {
        return PatientExportFormatSchema;
    },
    get PatientExportNotIncludedSchema () {
        return PatientExportNotIncludedSchema;
    },
    get PatientExportQuerySchema () {
        return PatientExportQuerySchema;
    },
    get PatientExportSectionSchema () {
        return PatientExportSectionSchema;
    },
    get PatientRecordExportSchema () {
        return PatientRecordExportSchema;
    },
    get patientExportFilename () {
        return patientExportFilename;
    }
});
const _zod = require("zod");
const _patientdetail = require("./patient-detail");
const PatientExportFormatSchema = _zod.z.enum([
    'pdf',
    'json'
]);
const PatientExportQuerySchema = _zod.z.object({
    format: PatientExportFormatSchema
}).strict();
const PATIENT_EXPORT_SCHEMA_VERSION = 1;
const PatientExportSectionSchema = _zod.z.enum([
    'demographics',
    'clinicalAlerts'
]);
const PatientExportNotIncludedSchema = _zod.z.enum([
    'encounters',
    'vitals',
    'labResults',
    'attachments'
]);
const PATIENT_EXPORT_SECTIONS_V1 = Object.freeze([
    'demographics',
    'clinicalAlerts'
]);
const PATIENT_EXPORT_NOT_INCLUDED_V1 = Object.freeze([
    'encounters',
    'vitals',
    'labResults',
    'attachments'
]);
/**
 * The export id equals the request id on the export's `audit_events` row.
 * The request id is a server ULID (or an `X-Request-Id` the caller sent), so
 * this is an opaque token, not a uuid. Bounded charset and length so a
 * caller-supplied header can't put arbitrary text into the file.
 */ const ExportIdSchema = _zod.z.string().regex(/^[A-Za-z0-9._:-]{1,128}$/);
const PatientRecordExportSchema = _zod.z.object({
    schemaVersion: _zod.z.literal(PATIENT_EXPORT_SCHEMA_VERSION),
    exportId: ExportIdSchema,
    exportedAt: _zod.z.string().datetime({
        offset: true
    }),
    source: _zod.z.object({
        system: _zod.z.literal('helix-emr')
    }).strict(),
    sections: _zod.z.array(PatientExportSectionSchema).min(1),
    notIncluded: _zod.z.array(PatientExportNotIncludedSchema),
    patient: _patientdetail.PatientDetailSchema.omit({
        updatedAt: true
    })
}).strict();
const PatientIdSchema = _zod.z.string().uuid();
/** `YYYYMMDD` with a plausible month and day. */ const FilenameDateSchema = _zod.z.string().regex(/^\d{4}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])$/);
function patientExportFilename(patientId, format, date) {
    if (!PatientIdSchema.safeParse(patientId).success) {
        throw new Error('patientExportFilename: patientId must be a uuid');
    }
    if (!FilenameDateSchema.safeParse(date).success) {
        throw new Error('patientExportFilename: date must be YYYYMMDD');
    }
    if (!PatientExportFormatSchema.safeParse(format).success) {
        throw new Error('patientExportFilename: unknown format');
    }
    return `patient-record-${patientId.toLowerCase()}-${date}.${format}`;
}
